import React from 'react'
import { Navbar } from '../component/shared/Navbar'
import { PageContainer } from '../component/styled/PageContainer'
import { Box, Grid } from '@mui/material'
import { Helmet } from 'react-helmet-async'
import { QuickLinksCard } from '../component/dashboard/QuickLinksCard'
import { InfoCard } from '../component/dashboard/InfoCard'
import { DocumentCard } from '../component/dashboard/DocumentCard'
import { CalendarCard } from '../component/dashboard/CalendarCard'
import { ApplicationLinksCard } from '../component/dashboard/ApplicationLinksCard'
import { useAuth } from '../api/context/UserAuthContext'

export const DashboardScreen = () => {
  const { user } = useAuth()

  return (
    <Box bgcolor='#f6f6f6'>
      <Helmet titleTemplate='%s | Staff Portal' defaultTitle='Staff Portal'>
        <title>Dashboard</title>
      </Helmet>

      <PageContainer>
        <Navbar />
        <Grid container spacing={2} p={{ xs: 1, md: 5 }}>
          <Grid item xs={12} sm={12} md={6} lg={8}>
            <InfoCard data={user} />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={4}>
            <CalendarCard />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <QuickLinksCard />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <DocumentCard permission={user?.permission} />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <ApplicationLinksCard permission={user?.permission} />
          </Grid>
        </Grid>
      </PageContainer>
    </Box>
  )
}
